import { useCallback, useEffect, useState } from "react";
import TransTable from "../common/TransTable";
import { Box, IconButton, Typography } from "@mui/material";
import Iconify from "../common/Iconify";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { currencyformater } from "../common/TransForm/currencyformater";
import { Notification } from "../common/Notification";

export default function InvoicesList() {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [notification, setnotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [downloadingId, setDownloadingId] = useState(null);
  
  // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  
  // Excel download state
  const [allExcelData, setAllExcelData] = useState([]);

  const handleDownloadInvoice = async (invoiceId) => {
    try {
      setDownloadingId(invoiceId);
      
      const response = await Axios.get(
        `${base_url}/api/pot/admin/invoices/${invoiceId}/download/`,
        {
          ...Config,
          responseType: 'blob'
        }
      );

      if (response?.status === 200) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${invoiceId}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
      
      setDownloadingId(null);
    } catch (error) {
      setDownloadingId(null);
      RefreshToken(error, setErrorMessage, setnotification);
    }
  };

  const InvoicesTableColumns = [
    {
      key: 'invoice_number',
      label: "Invoice No",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "player_name",
      label: "Player Name",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "round_id",
      label: "Round ID",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "number_of_picks",
      label: "No of Picks",
      align: "center",
      fontSize: '15px'
    },
    {
      key: "total_amount",
      label: "Amount",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return (
          <Typography>
            {'USD'} {currencyformater(data["total_amount"])}
          </Typography>
        );
      },
    },
    {
      key: "action",
      label: "Download",
      align: "center",
      valueRenderer: (data) => {
        return (
          <Box>
            <IconButton 
              onClick={() => handleDownloadInvoice(data.id)}
              disabled={downloadingId === data.id}
            >
              <Iconify 
                icon={downloadingId === data.id ? "eos-icons:loading" : "eva:download-outline"} 
                size="small" 
                color="primary.main" 
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  const InvoicesExcelTableColumns = [
    {
      key: 'invoice_no',
      label: "Invoice No",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "player_name",
      label: "Player Name",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "round_id",
      label: "Round ID",
      align: "left",
      fontSize: '15px'
    },
    {
      key: "no_of_picks",
      label: "No of Picks",
      align: "center",
      fontSize: '15px'
    },
    {
      key: "amount",
      label: "Amount",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${'USD'} ${currencyformater(data["amount"])}`;
      },
    },
  ];

  // Main function to get invoices with pagination, sorting, and search
  const getInvoices = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
    setInvoices([]);
    try {
      setLoading(true);

      // Build query parameters
      let queryParams = `page=${page}&limit=${limit}`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;
      }

      // Add search parameter if provided
      if (search && search.trim() !== '') {
        queryParams += `&search=${encodeURIComponent(search.trim())}`;
      }

      const response = await Axios.get(
        `${base_url}/api/pot/admin/invoices/?${queryParams}`, 
        Config
      );


      if (response?.status === 200) {
        let startIndex = (page - 1) * limit + 1;
        let data = response?.data?.results || response?.data;
        
        data.map(item => {
          item.serial_no = startIndex;
          startIndex += 1;
        });
        
        setInvoices(data);
        setTotalCount(response?.data?.count || data.length);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setnotification);
    }
  }, []);

  // Get all invoices for Excel download (without pagination)
  const getAllInvoicesForExcel = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(
        `${base_url}/api/pot/admin/invoices/export/`, // Endpoint without pagination
        Config
      );
      if (response?.status === 200) {
        setLoading(false);
        return response?.data.results;
      }
      setLoading(false);
      return [];
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setnotification);
      return [];
    }
  };

  // Handle Excel download
  // const handleExcelDownload = async () => {
  //   try {
  //     setLoading(true);
  //     const allInvoicesData = await getAllInvoicesForExcel();
      
  //     if (allInvoicesData.length > 0) {
  //       setAllExcelData(allInvoicesData);
  //       setTimeout(() => {
  //         setAllExcelData(allInvoicesData);
  //       }, 100);
  //     } else {
  //       // Fallback to current displayed data if API fails
  //       setAllExcelData(invoices);
  //     }
  //   } catch (error) {
  //     console.error('Error downloading Excel:', error);
  //     setAllExcelData(invoices);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // Handle Excel download - FIXED VERSION
const handleExcelDownload = async () => {
  try {
    setLoading(true);
    const allInvoicesData = await getAllInvoicesForExcel();
    
    if (allInvoicesData.length > 0) {
      // Add serial numbers to all data
      const dataWithSerialNo = allInvoicesData.map((item, index) => ({
        ...item,
        serial_no: index + 1
      }));
      
      setAllExcelData(dataWithSerialNo);
      
      // Small delay to ensure state is updated
      await new Promise(resolve => setTimeout(resolve, 100));
    } else {
      // Fallback to current displayed data if API fails
      setAllExcelData(invoices);
    }
  } catch (error) {
    console.error('Error downloading Excel:', error);
    setAllExcelData(invoices);
  } finally {
    setLoading(false);
  }
};

  // Handle pagination change
  const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    getInvoices(page + 1, rowsPerPage, sortBy, sortOrder, searchQuery);
  }, [sortBy, sortOrder, searchQuery, getInvoices]);

  // Handle sorting change
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    setCurrentPage(0);
    getInvoices(1, rowsPerPage, orderBy, order, searchQuery);
  }, [rowsPerPage, searchQuery, getInvoices]);

  // Handle search
  const handleSearch = useCallback((searchValue) => {
    setSearchQuery(searchValue);
    setCurrentPage(0);
    getInvoices(1, rowsPerPage, sortBy, sortOrder, searchValue);
  }, [rowsPerPage, sortBy, sortOrder, getInvoices]);

  useEffect(() => {
    getInvoices(1, 10); // Initial load
  }, []);

  return (
    <>
      <Box>
        <TransTable
          pageTitle="Invoices"
          showAddBtn={false}
          showSearch={true}
          checkbox={false}
          columns={InvoicesTableColumns}
          excelColumns={InvoicesExcelTableColumns}
          rows={invoices}
          isExcel={true}
          isLoading={loading}
          filter_keys={['invoice_number', 'player_name', 'round_id']}
          
          // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
          
          // Search props
          onSearch={handleSearch}
          searchQuery={searchQuery}
          
          // Excel download props
          customExcelData={allExcelData}
          onExcelDownload={handleExcelDownload}
        />
        <Notification 
          message={errorMessage} 
          setopen={setnotification} 
          type={'error'} 
          show={notification} 
        />
      </Box>
    </>
  );
}